import { createContext, useContext, useState } from "react";

const INITIAL_COORDS = {
  topLeftLng: -118.52031247275694,
  topLeftLat: 34.26728827119982,
  bottomRightLat: 33.78743855506191,
  bottomRightLng: -117.75531165205248
};

const PropertyContext = createContext({
  hoveredProperty: {},
  setHoveredProperty: (hoveredProperty: any) => {},
  collapsed: false,
  setCollapsed: (collapsed: boolean) => {},
  coords: INITIAL_COORDS,
  setCoords: (coords: any) => {}
});


export function PropertyProvider({ children }: any) {
  const [hoveredProperty, setHoveredProperty] = useState({});
  const [collapsed, setCollapsed] = useState(false);
  const [coords, setCoords] = useState(INITIAL_COORDS);
  
  return (
    <PropertyContext.Provider
      value={{
        hoveredProperty,
        setHoveredProperty,
        collapsed,
        setCollapsed,
        coords,
        setCoords
      }}
    >
      {children}
    </PropertyContext.Provider>
  );
}

const useProperty = () => useContext(PropertyContext);

export default useProperty;
